import {Button, FlexContainer, H1Text, H2Text, PH2Text, DescriptionText} from "../../../../../design";
import { useState, useEffect } from 'react';
import {Col, Row} from "react-awesome-styled-grid";
import {AmountDivideByHundred} from "../../../../../helper";
import DownloadIcon from "../../../../../assets/imgs/download.svg";
import SmallScreenView from "../../../../../components/smallscreen";
import React from "react";
import currencyFormatter from "../../../../../utils/currencyformatter";
import getformatteddate from "../../../../../utils/getformatteddate";
import { INVOICE_LINK } from "../../../../../appconstants";

type Props = {
  invoice: Object,
  download: Function,
  history: {
    push: Function,
  },
}

const InvoiceHeader = (props:Props) => {
  const {
    invoice, 
    download, 
    history, 
    partialPaymentDetails, 
    account
  } = props;
  const {location: { pathname }} = history;
  const [enablePayment, setEnablePayment] = useState(true);

  useEffect(() => {
    if (!partialPaymentDetails) return;
    setEnablePayment(false);
  }, [partialPaymentDetails]);

  const getTotalAmount = () => {
    return invoice && invoice.total;
  };

  return (
    <SmallScreenView sm xs>
      <FlexContainer
        display="block"
        borderRadius="3px"
        boxShadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
        className="text-center p-2 py-3 mx-1 mt-2 bg-white"
      >
        <Row className="w-100 px-2 align-items-center">
          {partialPaymentDetails && invoice?.currency &&
            <Col>
              <Row className="p-2" style={{ backgroundColor: "#EEEEFF" }}>
                <PH2Text fontWeight="bold" className="text-center">
                  Payment Terms
                </PH2Text>
              </Row>
              <Row>
                <Col>
                  <Col>
                    <DescriptionText>Initial Amount:</DescriptionText>
                    <DescriptionText color="#000000" fontWeight="400">
                      {partialPaymentDetails?.initialAmount? currencyFormatter(AmountDivideByHundred(partialPaymentDetails?.initialAmount), invoice.currency.name) : "N.A."}
                    </DescriptionText>
                  </Col>
                  <Col>
                    <DescriptionText>Due Date:</DescriptionText>
                    <DescriptionText color="#000000" fontWeight="400">
                      {partialPaymentDetails?.dueDate? getformatteddate(partialPaymentDetails?.dueDate,  account && account.timezone) : "N.A."}
                    </DescriptionText>
                  </Col>
                </Col>
                <Col>
                  <Col>
                  <DescriptionText>Pending Amount:</DescriptionText>
                    <DescriptionText color="#000000" fontWeight="400">
                      {partialPaymentDetails?.pendingAmount? currencyFormatter(AmountDivideByHundred(partialPaymentDetails?.pendingAmount), invoice.currency.name) : "N.A."}
                    </DescriptionText>
                  </Col>
                  <Col>
                    <DescriptionText>Late Fee:</DescriptionText>
                    <DescriptionText color="#000000" fontWeight="400">
                      {partialPaymentDetails?.lateFee? currencyFormatter(AmountDivideByHundred(partialPaymentDetails?.lateFee), invoice.currency.name) : "N.A."}
                    </DescriptionText>
                  </Col>
                </Col>
                <Col>
                  <Col>
                    <DescriptionText>Interest if Overdue:</DescriptionText>
                    <DescriptionText color="#000000" fontWeight="400">
                      {partialPaymentDetails?.overdueInterest? `${partialPaymentDetails?.overdueInterest}%` : "N.A."}
                    </DescriptionText>
                  </Col>
                </Col>
              </Row>
            </Col>
          }
          {partialPaymentDetails &&
            <FlexContainer
              display="flex"
              flexWrap="nowrap"
              className="mb-4 ml-2 mt-4"
            >
              <input 
                id="partialPaymentTermsAndConditionAcceptance" 
                type="checkbox"
                className="m-2m h-4"
                onChange={e => setEnablePayment(e.target.checked)}
              />
              <label 
                forHtml="partialPaymentTermsAndConditionAcceptance"
                className="text-center"
              >
                {INVOICE_LINK.PAY_TERMS}
              </label>
            </FlexContainer>
          }
          <Col xs={2} sm={4} className="align-items-start">
            <H2Text fontSize="16px" className="mb-0 align-items-center">Total Amount </H2Text>
            <H1Text className="mb-0 align-items-center pt-2">
              {invoice && invoice.currency && currencyFormatter(AmountDivideByHundred(getTotalAmount()), invoice.currency.name)}
            </H1Text>
          </Col>
          <Col xs={2} sm={4} className="align-items-end">
            <span className="align-items-center d-flex">
              <img style={{cursor: "pointer"}} onClick={download} src={DownloadIcon} className="px-4" alt={""}/>
              <Button 
                hidden={invoice && (invoice.status === "PAID" || invoice.status === "CANCELLED")} 
                onClick={() => enablePayment? props.history.push(`${pathname}/pay`) : null} 
                type="primary" 
                border="1px solid #40a9ff !important" 
                borderRadius="50px" 
                className="px-4 py-2"
                disabled={!enablePayment}
                >
                <span>PAY</span><span className="d-none d-sm-inline">&nbsp;NOW</span>
              </Button>
            </span>
          </Col>
        </Row>
      </FlexContainer>
    </SmallScreenView>
  )
};

export default InvoiceHeader
